// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
// plus backend check https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
export const isMobileDevice = (): boolean => {
  const isMobile = window.__AUTH_STATE__?.isMobile;

  if (!isMobile) {
    return false;
  }

  let hasTouchScreen;
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    // @ts-expect-error TS2339: Property 'msMaxTouchPoints' does not exist on type 'never'.
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true;
    } else {
      // @ts-expect-error TS2339: Property 'userAgent' does not exist on type 'never'.
      hasTouchScreen = Boolean(navigator.userAgent.match(/Mobi/));
    }
  }

  return hasTouchScreen;
};
